<script setup lang="ts">
  // eslint-disable-next-line import/no-unresolved
  import { useRegisterSW } from 'virtual:pwa-register/vue';

  const intervalMS =
    import.meta.env.VITE_NODE_ENV === 'development'
      ? 2 * 60 * 1000
      : 30 * 60 * 1000; // 测试环境12小时/正式环境30分钟检查一次更新
  const { offlineReady, needRefresh, updateServiceWorker } = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, r) {
      // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
      r &&
        setInterval(async () => {
          if (r.installing || !navigator) return;

          if ('connection' in navigator && !navigator.onLine) return;

          const resp = await fetch(swUrl, {
            cache: 'no-store',
            headers: {
              'cache': 'no-store',
              'cache-control': 'no-cache',
            },
          });

          if (resp?.status === 200) await r.update();
        }, intervalMS);
    },
  });

  async function close() {
    offlineReady.value = false;
    needRefresh.value = false;
  }

  function selfUpdateServiceWorker() {
    updateServiceWorker();
    close();
    // updateServiceWorker 有时候不会触发页面更新，这里做个兜底, 假设2.5s后还没出发更新
    setTimeout(() => {
      window.location.reload();
    }, 2500);
  }
</script>

<template>
  <div v-if="needRefresh" class="pwa-toast" role="alert">
    <div class="message">
      <!--      <span v-if="offlineReady"> 当前网络不佳，应用准备脱机工作 </span>-->
      <span> 系统有新版本可用，点击"重新加载"按钮更新~ </span>
    </div>
    <button v-if="needRefresh" @click="selfUpdateServiceWorker()">
      重新加载
    </button>
    <!--    <button @click="close"> 关闭 </button>-->
  </div>
</template>

<style>
  .pwa-toast {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 10000;
    margin: 16px;
    padding: 12px;
    text-align: left;
    background-color: white;
    border: 1px solid #8885;
    border-radius: 4px;
    box-shadow: 3px 4px 5px 0 #8885;
  }

  .pwa-toast .message {
    margin-bottom: 8px;
  }

  .pwa-toast button {
    margin-right: 5px;
    padding: 3px 10px;
    border: 1px solid #8885;
    border-radius: 2px;
    outline: none;
  }
</style>
